import Toast from '@src/components/toast';

export const DOWNLOAD_UNAVAILABLE_MESSAGE = '当前客户端暂未开放，请稍后再试';
export const RECHARGE_UNAVAILABLE_MESSAGE = '充值入口将于公测开启后开放，敬请期待';

export function handleDownloadLinkClick(event, downloadLink, onAvailable, unavailableMessage = DOWNLOAD_UNAVAILABLE_MESSAGE) {
  if (downloadLink) {
    if (onAvailable) onAvailable();
    return true;
  }

  event.preventDefault();
  Toast.info(unavailableMessage);
  return false;
}
